export { StyledProfileDetailsImage } from "./StyledProfileDetailsImage";
export { StyledProfileDetails } from "./StyledProfileDetails";
export { StyledProfileDetailsData } from "./StyledProfileDetailsData";
export { StyledProfileDetailsDataButtons } from "./StyledProfileDetailsData";
